export default {
  bottom: 'bottom',
};
